import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { AppointmentRecurring, NextRecurringSession, NextSession, NextSingleSession } from '@uplift/api';
import { useUserWithProfileQuery } from '@uplift/queries';
import { InCallUpcomingAppointmentSingleItem } from './items/InCallUpcomingAppointmentSingleItem.component';
import { InCallUpcomingAppointmentRecurringItem, InCallUpcomingAppointmentRecurringItemProps } from './items/InCallUpcomingAppointmentRecurringItem.component';


const useStyles = makeStyles({ name: 'InCallUpcomingAppointments' })(theme => ({
  root: {
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(1),
  },
  title: {
    fontSize: '18px',
    paddingBottom: theme.spacing(1),
  },
}));


export type InCallUpcomingAppointmentsProps = {
  patientId: string;
  nextSessions: NextSession[];
  nextSessionId?: string;
  excludeAppointmentId?: InCallUpcomingAppointmentRecurringItemProps['excludeAppointmentId'];
};


export const InCallUpcomingAppointments: React.VFC<InCallUpcomingAppointmentsProps> = (props) => {
  const { classes } = useStyles();
  const { data: patient } = useUserWithProfileQuery(props.patientId, { suspense: true });

  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>Your sessions with {patient?.profile.preferredName || patient?.user.firstName}</Typography>
      <Box>
        {props.nextSessions.map(s => {
          if ((!s.recurring || s.recurring === AppointmentRecurring.none) && !s.appointmentSeriesId) {
            return (
              <InCallUpcomingAppointmentSingleItem
                key={s.id}
                appointment={s as NextSingleSession}
                isNext={s.id === props.nextSessionId}
                cancellable
              />
            );
          }

          return (
            <InCallUpcomingAppointmentRecurringItem
              key={s.id}
              excludeAppointmentId={props.excludeAppointmentId}
              appointment={s as NextRecurringSession}
              isNext={s.id === props.nextSessionId}
              cancellable
            />
          );
        })}
      </Box>
    </Box>
  );
};
